import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      minHeight: "94vh",
      maxHeight: "98vh",
      minWidth: "98%",
      maxWidth: "90%",
    },
    "& + .pac-container": {
      zIndex: theme.zIndex.modal + 1
    },
    "& .MuiDialogTitle-root": {
      backgroundColor: theme.palette.custom.main,
      color: "#fff",
      padding: "8px 20px",
    },
    "& .MuiDialogTitle-root+.MuiDialogContent-root ": {
      paddingTop: 20,
    },
    "& .MuiDialogContent-root": {
      padding: "20px 20px",
    },
    "& .MuiDialogActions-root": {
      paddingInlineEnd: 24,
    },
  },
  estimatedcarousel:{
   paddingBottom:25,
   width:"100%",
  boxShadow:"1px 0px 8px 6px rgb(43 43 45 / 14%) !important"
  },
  Carouselcontainer:{
    padding:"0 22px",
    alignItems: "center",

   },
   carouselimages:{
    width : "100px"
  },
  Carouselgrids:{
  textAlign:"center"
  },
  Carouselcontent:{
    color: "black",
    fontSize: "12px !important",
    display: "flex",
    alignItems: "flex-end",
  },
}));

export default useStyles;
